(function(){
  // Every email typed into a form on cortclub.co.uk is saved here as well as in
  // Shopify. It used to post into a `cort` schema that stopped existing when the
  // databases were split on 3 Sep, so every sign-up since then failed with
  // "Invalid schema: cort" AND showed the visitor "Something went wrong".
  // It now writes to public.cort_waitlist, which anon may INSERT into and nobody
  // may read back.
  // 17 Sep: moved off the shared HAF database onto CØRT's own Supabase project,
  // so nothing about cørt sign-ups touches HAF any more (waitlist-cort-db-17sep).
  var SB='https://xgylwbaxwzwhfqdliiky.supabase.co';
  var KEY='eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InhneWx3YmF4d3p3aGZxZGxpaWt5Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3ODU1MTExMDAsImV4cCI6MjEwMTA4NzEwMH0.yHW3yq0QsPCDL6TF_fk93qZiL4zRYMpp2K3bdibqmzA';

  function save(email,source,perks){
    return fetch(SB+'/rest/v1/cort_waitlist',{
      method:'POST',
      keepalive:true,            // the Shopify form navigates away; let this finish
      headers:{
        'apikey':KEY,
        'Authorization':'Bearer '+KEY,
        'Content-Type':'application/json',
        'Prefer':'return=minimal'
      },
      body:JSON.stringify({email:email,source:source||'newsletter',perks:perks||[]})
    });
  }

  function showMsg(form,ok){
    var el=form.querySelector('#cort-form-msg');
    if(!el){el=document.createElement('span');el.id='cort-form-msg';form.appendChild(el);}
    el.className=ok?'success':'error';
    el.textContent=ok?'You are in! We will be in touch.':'Something went wrong — try again.';
    if(ok){setTimeout(function(){el.className='';},5000);}
  }

  function perksOf(form){
    return Array.prototype.map.call(
      form.querySelectorAll('.mw-tick:checked'), function(c){ return c.value; });
  }

  function sourceOf(form){
    return form.id==='cort-mw-form' ? 'cort-membership'
         : form.id==='cort-join-form' ? 'cort-community'
         : 'newsletter';
  }

  function wireForm(form){
    if(form.dataset.cortWired)return;
    form.dataset.cortWired='1';
    var emailInput=form.querySelector('input[type="email"],input[name="contact[email]"],input[name="customer[email]"]');
    if(!emailInput)return;
    form.addEventListener('submit',function(e){
      var email=(emailInput.value||'').trim();
      if(!email||!/^[^@]+@[^@]+\.[^@]+$/.test(email))return;
      save(email,sourceOf(form),perksOf(form)).then(function(r){
        // 409 = this address is already on the list, which is a success to a person
        showMsg(form, r.ok || r.status===409);
      }).catch(function(){showMsg(form,false);});
    });
  }

  function wireAll(){document.querySelectorAll('form').forEach(wireForm);}

  if(document.readyState==='loading'){
    document.addEventListener('DOMContentLoaded',wireAll);
  }else{
    wireAll();
  }

  // Catch dynamically rendered forms (Horizon uses JS sections)
  var mo=new MutationObserver(function(){wireAll();});
  mo.observe(document.body||document.documentElement,{childList:true,subtree:true});
})();
